import { useEffect } from 'react';

// Stripe redirects here after successful payment with ?session_id=xxx&locale=de-de
// We forward to the locale root with ?paid=true so Calculator shows the download state.
export default function SuccessRedirect() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const locale = params.get('locale') || 'en-us';
    const localePath = locale === 'en-us' ? '' : locale + '/';
    window.location.replace('/' + localePath + '?paid=true');
  }, []);
  return null;
}
